<template lang="pug">
.PersonalAccountPageComponent
  personal-account-navigation
  .content
    router-view
</template>

<script>
import PersonalAccountNavigation from '@/components/PersonalAccount/PersonalAccountNavigation/PersonalAccountNavigation.vue'

export default {
  components: {
    PersonalAccountNavigation
  }
}
</script>

<style lang="sass" scoped>
.PersonalAccountPageComponent
</style>
